import { AutocompleteItem, Highlighted, HighlightParams, SearchItem } from "./types";

export function addHighlightedAttribute<TItem extends SearchItem>({ item, query }: HighlightParams<TItem>): Highlighted<SearchItem> {
  return {
    ...item,
    _highlightResult: {
      label: {
        value: query
          ? item.label.replace(new RegExp(query.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "gi"), (match: any) => {
              return `__aa-highlight__${match}__/aa-highlight__`;
            })
          : item.label,
      },
    },
  };
}